import { ExternalLink, Linkedin, Twitter } from "lucide-react";
import { Button } from "./ui/button";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-100 relative overflow-hidden">
      {/* Tech pattern overlay */}
      <div className="absolute inset-0 circuit-pattern opacity-10"></div>
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="flex justify-center mb-12">
          {/* Brand */}
          <div className="text-center max-w-2xl">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <span className="text-xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                PromptLiteracy.ai
              </span>
            </div>
            <p className="text-slate-300 mb-6 leading-relaxed">
                <span className="relative inline-block mr-2 align-middle">
                  <img 
                    src="/logo-bulb.png" 
                    alt="PromptLiteracy.ai" 
                    className="h-7 w-5 animate-pulse-tech relative z-10"
                  />
                  <div className="absolute inset-0 -inset-1">
                    <div className="h-full w-full rounded-full bg-gradient-radial blur-lg"></div>
                  </div>
                </span>
                AI and prompt literacy are rapidly evolving, becoming essential skills in our everyday lives. 
                PromptLiteracy.ai exists to help kids, teens, and lifelong learners understand and master the art of communicating with AI. 
                Our vision is a world where we don't just consume AI, but communicate with it clearly, shape it responsibly, and use it creatively and effectively.
            </p>
            <div className="flex justify-center space-x-2">
              <Button variant="ghost" size="icon" onClick={() => window.open('https://twitter.com/@logikbug', '_blank')} className="text-slate-300 hover:text-white hover:bg-white/10 rounded-xl transition-all">
                <Twitter className="h-5 w-5" />
              </Button>
              {/* Don't have this just yet
               <Button variant="ghost" size="icon" className="text-slate-300 hover:text-white hover:bg-white/10 rounded-xl transition-all">
                <Facebook className="h-5 w-5" />
              </Button> */}
              <Button variant="ghost" size="icon" onClick={() => window.open('https://www.linkedin.com/in/logikbug', '_blank')} className="text-slate-300 hover:text-white hover:bg-white/10 rounded-xl transition-all">
                <Linkedin className="h-5 w-5" />
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4 text-sm text-slate-400">
              <span>© 2025 PromptLiteracy. Part of the</span>
              <a 
                href="https://logikbug.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-1 text-primary hover:text-secondary transition-colors"
              >
                <span>Logikbug learning network</span>
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-slate-400">
              <a href="/tags" className="link-underline hover:text-primary transition-colors">
                Browse Tags
              </a>
              <a href="/privacy" className="link-underline hover:text-primary transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="link-underline hover:text-primary transition-colors">
                Terms of Service
              </a>
              <a href="/contact" className="link-underline hover:text-primary transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>

        {/* Logikbug Attribution */}
        <div className="text-center mt-8 pt-6 border-t border-slate-800">
          <p className="text-xs text-slate-500">
            Powered by innovative educational technology from the Logikbug ecosystem
          </p>
        </div>
      </div>
    </footer>
  );
}